<template>
  <div>
    <div class="overflow-auto">
      <table class="table" id="table-details">
        <thead>
          <tr>
            <th style="width: 163px;" class="ts-whitespace-no-wrap">
              {{ $t('retailSale.saleCode') }}
            </th>
            <th class="ts-whitespace-no-wrap">
              {{ $t('retailSale.productName') }}
            </th>
            <th style="width: 150px;" class="ts-whitespace-no-wrap">
              {{ $t('retailSale.uom') }}
            </th>
            <th style="width: 88px;" class="text-center ts-whitespace-no-wrap">
              {{ $t('retailSale.quantity') }}
            </th>
            <th style="width: 70px;" class="text-center ts-whitespace-no-wrap">
              {{ $t('retailSale.salePrice') }}
            </th>
            <th style="width: 88px;" class="text-center ts-whitespace-no-wrap">
              {{ $t('retailSale.discountType') }}
            </th>
            <th style="width: 88px;" class="text-center ts-whitespace-no-wrap">
              {{ $t('retailSale.discount') }}
            </th>
            <th style="width: 88px;" class="text-center ts-whitespace-no-wrap">
              {{ $t('retailSale.vat') }}
            </th>
            <th style="width: 100px;" class="ts-whitespace-no-wrap text-center">
              {{ $t('retailSale.amount') }}
            </th>
            <th class="text-center" style="width: 35px;">
              <a href="#" @click.prevent="() => (visible = true)">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in model.detail_list" :key="index">
            <td>
              <a-select
                v-model="detail.pro_sale_code_id"
                :options="getSaleCodeList(detail.product_id)"
                @change="saleCodeChange(detail)"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control-plaintext"
                :value="getProductName(detail.product_id)"
                readonly
              />
              <div v-if="errors.has('detail_list.' + index + '.product_id')">
                {{ errors.first('detail_list.' + index + '.product_id') }}
              </div>
            </td>
            <td>
              <a-select
                v-model="detail.uom_id"
                :options="getUomList(detail.product_id)"
                :disabled="true"
              />
              <div
                class="validate"
                v-if="errors.has('detail_list.' + index + '.uom_id')"
              >
                {{ errors.first('detail_list.' + index + '.uom_id') }}
              </div>
            </td>
            <td class="text-center">
              <input
                v-model.number="detail.quantity"
                type="number"
                class="form-control text-center"
              />
              <div
                class="validate"
                v-if="errors.has('detail_list.' + index + '.quantity')"
              >
                {{ errors.first('detail_list.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <input
                v-model.number="detail.sale_price"
                disabled
                type="number"
                class="form-control-plaintext text-center"
              />
              <div
                class="validate"
                v-if="errors.has('detail_list.' + index + '.sale_price')"
              >
                {{ errors.first('detail_list.' + index + '.sale_price') }}
              </div>
            </td>
            <td>
              <select
                v-model="detail.discount_type"
                class="form-control"
                @change="sumByRow(detail)"
              >
                <option value="%">%</option>
                <option value="$">$</option>
              </select>
              <div
                class="validate"
                v-if="errors.has('detail_list.' + index + '.discount_type')"
              >
                {{ errors.first('detail_list.' + index + '.discount_type') }}
              </div>
            </td>
            <td>
              <input
                v-model.number="detail.discount_rate"
                type="number"
                class="form-control text-center"
              />
            </td>
            <td>
              <input
                v-model.number="detail.vat_rate"
                type="number"
                class="form-control text-center"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control-plaintext text-center"
                :value="sumByRow(detail)"
                readonly
              />
            </td>
            <td class="text-center">
              <a href="#" class="text-red" @click.prevent="removeItem(detail)">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
          <tr>
            <td colspan="8" class="text-right">
              <p>
                <b>{{ $t('retailSale.grandTotal') }} :</b>
              </p>
            </td>
            <td class="text-center">
              <p>
                <u>{{ grandTotal }}</u>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <a-modal
      v-model="visible"
      :title="$t('retailSale.product')"
      :maskClosable="false"
      @ok="handleOk"
      :cancelText="$t('cancel')"
      :okText="$t('ok')"
      :zIndex="1020"
      width="400px"
    >
      <div class="row">
        <div class="col-md-12">
          <input
            v-model="search"
            type="text"
            class="form-control background-search"
            @input="fetchProduct"
            :placeholder="$t('search')"
          />
        </div>
      </div>
      <br />
      <a-spin :spinning="fetching">
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
        <div class="spin-content">
          <div id="product-container">
            <div
              v-for="product in productLists"
              :key="product.product_id + '-' + product.pro_sale_code_id"
            >
              <ts-checkbox
                v-model="selectedProducts"
                class="font-12"
                :value="product"
                >{{ product.product_name_en }}</ts-checkbox
              >
            </div>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'

export default {
  name: 'retailSaleItemDetail',
  props: ['value', 'validate'],
  data() {
    this.fetchProduct = debounce(this.fetchProduct, 800)
    return {
      model: {},
      visible: false,
      fetching: false,
      search: null,
      productResources: [],
      selectedProducts: [],
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
    this.setEdit()
  },
  computed: {
    ...mapState('retailSale', ['edit_data']),
    productLists() {
      return this.productResources.filter(
        p =>
          !_.includes(
            this.model.detail_list.map(el => el.product_id),
            p.product_id
          )
      )
    },
    grandTotal() {
      if (!this.model.detail_list.length > 0) {
        return 0
      }
      return this.model.detail_list.reduce(
        (initial, row) => (initial += this.sumByRow(row)),
        0
      )
    }
  },
  methods: {
    ...mapActions('retailSale', ['searchProduct']),
    removeItem(row) {
      this.model.detail_list.splice(this.model.detail_list.indexOf(row), 1)
      this.selectedProducts.splice(
        this.selectedProducts.indexOf(
          this.selectedProducts.filter(p => p.product_id == row.product_id)[0]
        ),
        1
      )
    },
    fetchProduct() {
      this.fetching = true
      this.searchProduct({
        search: this.search
      })
        .then(response => {
          this.productResources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    handleOk() {
      if (!this.selectedProducts.length > 0) {
        return
      }
      this.selectedProducts.forEach(el => {
        el.sale_code
          .filter(s => s.u_o_m.is_default == true)
          .forEach(el => {
            if (
              !this.model.detail_list.find(d => d.product_id == el.product_id)
            ) {
              this.model.detail_list.push({
                product_id: el.product_id,
                uom_id: el.uom_id,
                quantity: 1,
                sale_price: el.product_price.sale_price,
                discount_type: '%',
                discount_rate: 0,
                vat_rate: 0,
                pro_sale_code_id: el.pro_sale_code_id
              })
            }
          })
      })
      this.clearFilter()
      this.visible = false
    },
    clearFilter() {
      this.search = null
    },
    saleCodeChange(row) {
      let product = this.selectedProducts
        .filter(p => p.product_id == row.product_id)
        .reduce(
          (initial, item) =>
            (initial = item.sale_code
              .filter(s => s.pro_sale_code_id == row.pro_sale_code_id)
              .reduce(
                (immolator, saleCode) =>
                  (immolator = {
                    sale_price: saleCode.product_price.sale_price,
                    uom_id: saleCode.uom_id
                  }),
                0
              )),
          0
        )
      row.sale_price = product.sale_price
      row.uom_id = product.uom_id
    },
    getProductName(product_id) {
      return this.selectedProducts
        .filter(p => p.product_id == product_id)
        .map(el => el.product_name_en)
        .reduce((init, item) => (init = item), null)
    },
    getSaleCodeList(product_id) {
      return this.selectedProducts
        .filter(p => p.product_id == product_id)
        .map(el =>
          el.sale_code.map(el => ({
            value: el.pro_sale_code_id,
            label: el.sale_code
          }))
        )
        .reduce((init, item) => (init = item), [])
    },
    getUomList(product_id) {
      return this.selectedProducts
        .filter(p => p.product_id == product_id)
        .map(product =>
          product.sale_code.map(el => ({
            value: el.u_o_m.uom_id,
            label: el.u_o_m.uom_name_en
          }))
        )
        .reduce((init, item) => (init = item), [])
    },
    sumByRow(row) {
      var price = row.quantity * row.sale_price
      var discount_amount = 0
      if (row.discount_type == '%') {
        discount_amount = row.discount_rate
          ? (row.discount_rate / 100) * price
          : 0
      } else {
        discount_amount = row.discount_rate
      }
      let price_after_discount = price - discount_amount
      let price_include_vat = row.vat_rate
        ? (row.vat_rate / 100) * price_after_discount
        : 0
      return price_after_discount + price_include_vat
    },
    setEdit() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.student_id = this.edit_data.student_id
        this.model.remarks = this.edit_data.remarks
        this.model.stock_out_date = this.edit_data.stock_out_date

        // push data to selected product
        this.edit_data.details.forEach(el => {
          this.selectedProducts.push(el.product)
          this.model.detail_list.push({
            product_id: el.product_id,
            uom_id: el.uom_id,
            quantity: el.quantity,
            sale_price: el.sale_price,
            discount_type: el.discount_type,
            discount_rate: el.discount_rate,
            vat_rate: el.vat_rate,
            pro_sale_code_id: el.product.sale_code
              .filter(s => s.uom_id == el.uom_id)
              .reduce((init, el) => (init = el.pro_sale_code_id), null)
          })
        })
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    visible: function(value) {
      if (value && this.productResources.length == 0) {
        this.fetchProduct()
      }
    }
  }
}
</script>

<style lang="css" scoped>
#product-container {
  height: 50vh;
  min-height: 30vh;
  overflow-y: scroll;
  padding: 10px 15px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.font-12 {
  font-size: 12px;
}
#table-details > thead > tr > th {
  padding: 5px 4px;
  background: #f2f3f4;
}
#table-details > tbody > tr > td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}

.background-search {
  background-color: #ffffff;
  background-image: url('https://www.pngkit.com/png/detail/507-5070665_search-folder-icon-icon.png');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
